import { ReactElement, useState, useEffect } from "react";
import close from "../../assets/icons/DELETE __ DARK.svg";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "./Modal";
import Button from "./Button";
import { DictionaryType } from "../../types";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import logo from "../../assets/icons/mocionLogo.svg";
import { changeViewMode, resetHomeSidebarInfo } from "../../lib/redux/slices/controlSlice";

type propsType = {
  children: ReactElement;
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  headerTitle: string;
  headerImage: any;
  sideBarMaxWidth: string;
  closeAction?:()=>void
  formChanged?: boolean;
  setDiscardChangesModal?: (e: boolean) => void;
  setDraft?: (e: string) => void;
  setFormChanged?: (e: boolean) => void;
};

const SideBar = ({
  sidebarOpen,
  closeAction,
  setSidebarOpen,
  children,
  headerImage,
  headerTitle,
  sideBarMaxWidth,
  setDiscardChangesModal,
  setDraft,
  setFormChanged,
  formChanged,
}: propsType) => {
  const [animationHandler, setAnimationHandler] = useState(false);
  const viewMode  = useSelector(
    (state: any) => state?.control?.viewMode
  );
  const {shared}:DictionaryType = useGetDictionary()
  const [closeDiscardChangesModal, setCloseDiscardChangesModal] = useState(false);
  const lang = useSelector((state: any) => state?.user?.lang);
  const dispatch = useDispatch()
  useEffect(() => {
    if (sidebarOpen) {
      setAnimationHandler(true); // Trigger open animation
    }
  }, [sidebarOpen]);

  const removeAnimation = () => {
    setAnimationHandler(false); // Trigger close animation
    setTimeout(() => {
      closeAction?.();
      setSidebarOpen(false); // Fully hide sidebar after animation
      dispatch(resetHomeSidebarInfo())
    }, 200); // Match this duration to your CSS transition time
  };

  const DiscardChangesModalHandler = () => {
    //if (formChanged) setDiscardChangesModal &&
     if(setDiscardChangesModal && !viewMode){
      setCloseDiscardChangesModal(true)
     }else if(!viewMode){
      setCloseDiscardChangesModal(true)
     }else{
      //@ts-ignore
      dispatch(changeViewMode(false))

      removeAnimation();
     }
    // else removeAnimation();
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-20 transition-opacity backdrop-blur ${
          sidebarOpen
            ? "opacity-100 visible backdrop-blur-sm"
            : "opacity-0 invisible"
        }`}
        onClick={() => {
          DiscardChangesModalHandler();
          //removeAnimation();
        }}
      />
      <aside
        className={`fixed shadow-lg top-0 ${
          lang == "ar" ? "left-0" : "right-0"
        }  z-[60] h-dvh ${
          sideBarMaxWidth ? sideBarMaxWidth : "max-w-[500px]"
        } w-full bg-white duration-300 transition-transform transform ${
          animationHandler
            ? lang == "ar"
              ? "-translate-x-0"
              : "translate-x-0"
            : lang == "ar"
            ? "-translate-x-full"
            : "translate-x-full"
        }`}
        aria-label="Sidebar"
      >
        <div  className="h-dvh overflow-y-auto customScroll ">
          <div className="bg-primary dark:bg-primaryLight h-[51px] px-3 flex justify-between items-center">
            <div className="text-white flex flex-row gap-1 items-center justify-center">
              <img loading="lazy" className="w-10" src={headerImage} alt="Header" />
              <h2 className="text-white pt-4 text-lg">{headerTitle}</h2>
            </div>
            <button
              onClick={e=>{
                e.preventDefault()
                DiscardChangesModalHandler()}}
              className="text-xl text-white transition duration-300"
            >
              <img loading="lazy" src={close} alt="Close" />
            </button>
          </div>
          {/* Pass removeAnimation to children */}
          {React.cloneElement(children, {
            removeAnimation,
            DiscardChangesModalHandler,
            setDraft,
            setFormChanged,
          })}
        </div>
          <div className=" absolute z-50">
        <Modal
          modalMaxWidth="max-w-lg"
          portal={true}
          isOpen={closeDiscardChangesModal}
        >
          <div className="  flex flex-col gap-8 px-12 py-5 ">
            <div className="flex flex-col justify-center items-center gap-4 text-center ">
              <img loading="lazy" width={200} height={200} src={logo} alt="mocion-logo" />
              <div>
                <h2>{shared.attention}!!</h2>
                <p className="text-lg font-normal  text-[#1E1850] break-words leading-relaxed whitespace-pre-wrap  ">
                  {shared.discard_changes}
                </p>
              </div>
              <div className="mt-6 flex flex-col items-center justify-center gap-6  w-full">
                <Button
                  customeStyle=" bg-primary text-white  w-full rounded-full  text-lg py-4  "
                  text={shared.yes}
                  width="max-w-[400px] w-full"
                  onClick={() => {
                   
                    removeAnimation();
                    
                    setCloseDiscardChangesModal(false);
                  }}
                />
                <Button
                  customeStyle="bg-white text-primary dark:text-white   w-full rounded-full text-lg py-4 "
                  text={shared.no}
                  width="max-w-[400px] w-full"
                  onClick={() => {
                    setCloseDiscardChangesModal(false);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
      </aside>
    
    </>
  );
};

export default SideBar;
